import { createSlice } from '@reduxjs/toolkit'
import { MainMenuTypes, menuItems } from 'static-data/mainSideMenu'

const initialState = {
  initialMenu: menuItems as MainMenuTypes,
  menuItems: menuItems as MainMenuTypes,
  currentRoute: '' as string,
  isExpanded: false,
}

const sideMenuReducer = createSlice({
  name: 'sideMenu',
  initialState,
  reducers: {
    resetToInitialState(state) {
      state.initialMenu = menuItems as MainMenuTypes
      state.menuItems = menuItems as MainMenuTypes
      state.currentRoute = ''
      state.isExpanded = false
    },
    setMenuState(state, { payload }) {
      state.menuItems = payload
    },
    setIsExpandedState(state, { payload }) {
      state.isExpanded = payload
    },
    setCurrentRouteState(state, { payload }) {
      state.currentRoute = payload
    },
  },
})

export const {
  setMenuState,
  setCurrentRouteState,
  setIsExpandedState,
  resetToInitialState,
} = sideMenuReducer.actions

export const resetToInitial = () => (dispatch: any) => {
  dispatch(resetToInitialState())
}

export const setMenu = (sideMenuItems: any) => (dispatch: any) => {
  dispatch(setMenuState(sideMenuItems))
}

export const setIsExpanded = (payload: any) => (dispatch: any) => {
  dispatch(setIsExpandedState(payload))
}

export const setCurrentRoute = (currentRoute: string) => (dispatch: any) => {
  dispatch(setCurrentRouteState(currentRoute))
}

export default sideMenuReducer.reducer
